// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon18(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="m3.26 24.91-.26.257a.335.335 0 0 0 .474.473l.256-.26a.333.333 0 0 0-.47-.47ZM5.081 23.087l-.257.26a.333.333 0 0 0 .47.47l.257-.257a.333.333 0 0 0-.362-.545.333.333 0 0 0-.108.072ZM6.9 21.267l-.257.26a.333.333 0 1 0 .47.474l.26-.257a.335.335 0 0 0-.235-.574.338.338 0 0 0-.238.097ZM4.94 26.59l-.26.256a.34.34 0 1 0 .474.487l.257-.26a.332.332 0 0 0 .019-.489.334.334 0 0 0-.49.019v-.014ZM6.76 24.766l-.257.26a.334.334 0 1 0 .47.47l.26-.257a.335.335 0 1 0-.473-.473ZM8.58 22.946l-.256.26a.333.333 0 1 0 .47.46l.26-.257a.335.335 0 0 0-.473-.473v.01ZM6.62 28.27l-.26.256a.335.335 0 1 0 .473.474l.257-.26a.333.333 0 0 0-.47-.47ZM8.44 26.448l-.257.26a.338.338 0 0 0 .247.572.337.337 0 0 0 .237-.102l.26-.257a.335.335 0 0 0-.474-.473H8.44ZM10.26 24.627l-.256.26a.333.333 0 0 0 .47.47l.26-.256a.335.335 0 0 0-.473-.474ZM21.52 6.666l-.26.257a.335.335 0 0 0 .473.473l.257-.26a.333.333 0 0 0-.47-.47ZM23.333 4.83l-.26.257a.336.336 0 0 0 .364.546.335.335 0 0 0 .109-.073l.257-.26a.333.333 0 0 0-.47-.47ZM25.16 3l-.26.257a.333.333 0 0 0 .237.568.334.334 0 0 0 .236-.098l.257-.257a.334.334 0 0 0-.47-.47ZM23.2 8.335l-.26.256a.335.335 0 0 0 .473.474l.253-.264a.334.334 0 1 0-.466-.466ZM25.02 6.511l-.26.257a.335.335 0 0 0 .473.473l.257-.26a.333.333 0 1 0-.47-.47ZM26.84 4.69l-.256.256a.333.333 0 0 0 .47.47l.257-.256a.333.333 0 0 0-.47-.47ZM24.88 10l-.26.256a.334.334 0 0 0 .473.473l.256-.26a.334.334 0 0 0-.095-.563.334.334 0 0 0-.375.093ZM26.7 8.19l-.26.257a.335.335 0 0 0 .473.474l.257-.26a.333.333 0 1 0-.47-.47ZM28.52 6.37l-.257.257a.333.333 0 1 0 .47.47l.257-.257a.333.333 0 1 0-.47-.47Z" />
        <path d="m23.81 16 6.573-6.574a5.524 5.524 0 0 0-7.81-7.81L16 8.19 9.43 1.616A5.525 5.525 0 1 0 1.616 9.43L8.19 16l-6.574 6.573a5.523 5.523 0 0 0 7.81 7.81L16 23.81l6.57 6.573a5.524 5.524 0 1 0 7.813-7.813L23.81 16ZM2.09 8.956A4.857 4.857 0 0 1 8.956 2.09l6.574 6.576-6.864 6.864L2.09 8.956ZM8.956 29.91a4.856 4.856 0 1 1-6.866-6.867L23.043 2.09a4.856 4.856 0 1 1 6.867 6.866L8.956 29.91Zm20.954 0a4.85 4.85 0 0 1-6.867 0l-6.573-6.577 6.863-6.863 6.577 6.573a4.86 4.86 0 0 1 0 6.867Z" />
        <path d="M17.956 10.898a1.457 1.457 0 0 0-2.056 0l-5 5a1.457 1.457 0 0 0 0 2.056l3.146 3.147a1.457 1.457 0 0 0 2.057 0l5-5a1.457 1.457 0 0 0 0-2.057l-3.147-3.146Zm2.667 4.73-5 5a.782.782 0 0 1-1.11 0l-3.147-3.147a.785.785 0 0 1 0-1.11l5-5a.784.784 0 0 1 1.11 0l3.147 3.147a.784.784 0 0 1 .007 1.11h-.007Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon18;
